// import { useState, useEffect } from 'react';
import LecturerSidebar from '../components/LecturerSidebar.js';
import '../styles/LecturerSessions.css';
import LecturerCalendar from '../components/LecturerCalendar.js';

export default function LecturerSessions() {
    return (
        <div className="lecture-dashboard-panel">
            { /* Sidebar */}
            <LecturerSidebar />
            {/* Main Content */}
            <div className='main-content'>
                {/* Header */}
                <div className='header'>
                    <h1 className='header-title'>Kalendarz zajęć</h1>
                </div>
                <div className='dashboard'>
                    <h2 className='page-title'>Kalendarz zajęć</h2>
                    <p className='page-subtitle'>Kalendarz zajęć i wydarzeń</p>
                </div>
                <div className='menagment-content'>
                    <LecturerCalendar />
                </div>
            </div>
        </div>
    );
}